import { SearchIcon } from "@heroicons/react/outline";
import { useTranslation } from "react-i18next";
import { classNames } from "../../helpers";
import ChatCard from "./chat-card/ChatCard";
import useSearchParticipant from "../../hooks/useSearchParticipant";
import { useEffect, useState } from "react";

type MessagesProps = {
  classStyles?: string;
  userList: any;
  getUser: any;
  setActiveConversation: any;
  activeConversation: any;
  setShowChatList?: () => void;
};
export default function MessagesContainer(props: MessagesProps) {
  const {
    classStyles,
    userList,
    activeConversation,
    setActiveConversation,
    setShowChatList,
  } = props;
  const { t } = useTranslation("", {
    keyPrefix: "page.chat",
  });
  const { onSearch } = useSearchParticipant();
  const [participantListData, setParticipantListData] = useState([]);

  const searchParticipants = (val: string) => {
    let dataParticipants = onSearch(val, userList);
    setParticipantListData(dataParticipants);
  };
  useEffect(() => {
    if (!!userList) {
      setParticipantListData(userList);
    }
  }, [userList]);
  return (
    <>
      <div className="w-full flex flex-col gap-4 bg-white p-6 md:pb-4">
        <h3 className="text-gray-800 text-xl font-medium">{t("messages")}</h3>
        <div className="relative rounded-md shadow-sm flex justify-between gap-4">
          <div className="absolute inset-y-0 rtl:right-0 lrt:left-0 rtl:pr-3 ltr:pl-3  flex items-center pointer-events-none">
            <SearchIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
          </div>
          <input
            type="text"
            name="search"
            id="search"
            className="focus:ring-brandblue-500 focus:border-brandblue-500 block w-full rtl:pr-10 ltr:pl-10  md:text-sm border-gray-300 rounded-md"
            placeholder={t("search")}
            onChange={(e) => {
              searchParticipants(e.target.value);
            }}
          />
        </div>
      </div>

      <div
        className={classNames(
          "relative  w-full  overflow-y-auto  flex flex-col gap-2 bg-white px-5   md:p-6  md:pt-0",
          !!classStyles ? classStyles : "max-h-[340px]"
        )}
      >
        {participantListData.map((conversation: any) => {
          // Helper for getting the data of the first participant
          const [userAvatar, name, objectType] = (() => {
            const participant =
              conversation.participants.length > 0
                ? conversation?.participants[0]
                : undefined;

            if (participant) {
              return [
                participant.avatar,
                participant?.fullName ?? participant?.firstName,
                participant?.objectType,
              ];
            }

            return ["", "", ""];
          })();
          if (!!name)
            return (
              <ChatCard
                message={""}
                conversationId={conversation.data.twilioId}
                senderName={name}
                senderType={objectType?.toLowerCase()}
                key={conversation.id}
                active={activeConversation?.id === conversation.id}
                unreadMessages={conversation.unreadCounter}
                senderImage={userAvatar}
                onClick={(e) => {
                  setActiveConversation(conversation?.id, true);
                  setShowChatList && setShowChatList();
                }}
              />
            );
        })}
      </div>
    </>
  );
}
